import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

export function getPaginatedData(
    {
        ResultID,
        StartOffset,
        RecordsCount,
        SortFields,
        Filter,
        GroupKeys,
        GroupFields,
    },
    {FarmID, ClientID, LocalUserID} = {}
) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.getPaginatedData({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        // GroupKeys - pełna ścieżka do grupy ostatniego poziomu; zawęża wiersze do tej grupy
        body: {
            ResultID,
            StartOffset,
            RecordsCount,
            SortFields,
            Filter,
            GroupKeys,
            // poziomy grupowania (jak w getGroupedData) - potrzebne do GroupKeys poziomów z przedziałami
            GroupFields,
        },
    });
}
